exports.scriptTemplateAtLeast = (signers, K) => `
    {
        atLeast( ${K.toString()}, Coll( ${signers} ))
    }`.trim()
exports.scriptTemplate = (signers) => `
    {
        ${signers}
    }`.trim()
